import { Platform } from 'react-native'

// /////////////////////////////////
export type Palette = {
  bordeaux: string,
  red: string,
  orange: string,
  yellow: string,
  green: string,
  blue: string,
  theaterShowblue: string,
  black: string,
  white: string,
  transparent: string,
  brown: string,
  grey: string,
  lightgrey: string,
  taupe: string,
  lighttaupe: string,
  xlighttapue: string,
  xlightgrey: string,
  disabledcolor: string,
  disabledborder: string,
  facebookblue: string,
}

export type Colors = Palette & {
  // Components
  primary: string,
  screen: string,
  section: string,
  panel: string | Array<string>,
  body: string,
  item: string,
  sectionheader: string,
  divider: string,
  placeholder: string,
  underlay: string,
  modal: string,
  buttons: {
    plain: {text: string},
    primary: {text: string, background: string, border: string, filler: string, disabled: string},
    secondary: {text: string, background: string, border: string, filler: string, disabled: string}
  }
}

export type Variant = 'default' | 'panel'
export type ThemeName = 'base' | 'efteling' | 'boardingpass' | 'showtimes' | 'negenpleinenfestijn' | 'newyear' | 'theatershow'

export type Theme = {} & {
  spacing: Array<number>,
  sizes: Array<number>,
  fontSizes: {[string]: number},
  lineHeights: {[string]: number},
  fontWeights: {[string]: number},
  elevation: {[string]: number},
  colors: Colors
}

export type LazyTheme = (variant: Variant) => Theme

export const main: LazyTheme = (variant: Variant = 'default') => ({
  // /////////////////////////////
  spacing: [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96],
  // /////////////////////////////
  sizes: [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96],
  // /////////////////////////////
  fonts: {
    primary: Platform.select({ ios: 'ErnestineComp-Bold', android: 'ernestine_comp_bold' }),
    secondary: Platform.select({ ios: 'ErnestineComp', android: 'ernestine_comp_regular' }),
    body: Platform.select({ ios: 'Open Sans', android: 'opensans_regular' })
  },
  // /////////////////////////////
  // More information:
  // https://developer.apple.com/ios/human-interface-guidelines/visual-design/typography/
  fontSizes: {
    title1: 20,
    title2: 18,
    title3: 16,
    subhead1: 14,
    subhead2: 12,
    caption1: 14,
    caption2: 12,
    caption3: 11,
    body1: 16,
    body2: 14,
    body3: 12
  },
  lineHeights: {
    title1: 26,
    title2: 24,
    title3: 22,
    subhead1: 20,
    subhead2: 18,
    caption1: 20,
    caption2: 18,
    caption3: 14,
    body1: 28,
    body2: 26,
    body3: 24
  },
  // Golden ratio
  // https://medium.com/@zkareemz/golden-ratio-62b3b6d4282a
  // lineHeight: 1.313,
  // /////////////////////////////
  fontWeights: {
    'light': 300,
    'regular': 400,
    'normal': 400,
    'semi-bold': 600,
    'bold': 700
  },
  // /////////////////////////////
  // More information:
  // https://material.io/guidelines/material-design/elevation-shadows.html#elevation-shadows-elevation-android
  elevation: {
    'none': 0,
    'item': 1,
    'card': 1,
    'actionbar': 4,
    'fab': 6,
    'snackbar': 6,
    'tabbar': 8,
    'drawer': 16,
    'dialog': 24
  },
  radius: {
    default: 3
  },
  // $FlowFixMe
  colors: {}
}: Theme)

export default main
